import { type SelectHTMLAttributes, forwardRef } from 'react';
import { ChevronDown, CircleAlert } from 'lucide-react';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, error, id, className = '', children, ...props }, ref) => {
    const selectId = id ?? props.name;
    return (
      <div className="flex flex-col gap-1">
        {label && (
          <label htmlFor={selectId} className="text-sm font-medium text-fg">
            {label}
          </label>
        )}
        <span className="relative flex">
          <select
            ref={ref}
            id={selectId}
            className={`h-10 w-full appearance-none rounded-control border bg-surface-0 pl-3 pr-9 text-sm text-fg transition-colors duration-fast disabled:cursor-not-allowed disabled:bg-surface-2 disabled:text-fg-muted ${
              error ? 'border-danger' : 'border-line-strong'
            } ${className}`}
            aria-invalid={Boolean(error)}
            {...props}
          >
            {children}
          </select>
          <ChevronDown
            size={16}
            aria-hidden="true"
            className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-fg-muted"
          />
        </span>
        {error && (
          <span className="flex items-center gap-1 text-xs text-danger">
            <CircleAlert size={14} aria-hidden="true" />
            {error}
          </span>
        )}
      </div>
    );
  },
);
Select.displayName = 'Select';
